<!-- 百家号详细信息 -->
<template>
  <div class="all">
    <Top :hasShare="false"/>
    <!-- 顶部 -->
    <div class="top">
      <!-- logo -->
      <div class="logo">
        <div class="left">
          <van-image
            v-if="userInfo.headPhoto"
            round
            width="50px"
            height="50px"
            fit="cover"
            :src="$global.imgUrl + userInfo.headPhoto"
          />
          <span v-else>
            <Big width="50" height="50" size="20" :big="userInfo.realname" />
          </span>
          <!-- <img 
               style="width:50px; height: 50px"
               src="@/assets/img/login/4.png"
               alt=""> -->
        </div>
        <div class="right">
          <div class="title">
            {{ userInfo.realname }}
          </div>
        </div>
      </div>
      <!-- 职称 -->
      <div class="public-item">
        <div class="public-title">
          <img src="@/assets/img/mobileImg/title.png" alt="" />
          <span>职称</span>
        </div>
        <div class="public-text" v-for="(item, index) in title" :key="index">
          {{ item.levelTwo }}
        </div>
      </div>
      <!-- 研究方向 -->
      <div class="public-item">
        <div class="public-title">
          <img src="@/assets/img/mobileImg/yjfx.png" alt="" />
          <span>学科领域</span>
        </div>
        <div class="public-text" v-for="(item, index) in subject" :key="index">
          {{ item.levelTwoName }}
        </div>
      </div>
      <!-- 工作单位 -->
      <div class="public-item">
        <div class="public-title">
          <img src="@/assets/img/mobileImg/work.png" alt="" />
          <span>工作单位</span>
        </div>
        <div class="public-text jianjie-title">
          <span>{{ userInfo.unit }}</span>
          <van-icon
            v-if="userInfo.orgId"
            name="arrow"
            @click="jumpOrg(userInfo.orgId)"
          />
        </div>
      </div>
      <!-- 职务 -->
      <div class="public-item">
        <div class="public-title">
          <img src="@/assets/img/mobileImg/post.png" alt="" />
          <span>职务</span>
        </div>
        <div class="public-text">
          {{ userInfo.job }}
        </div>
      </div>
      <!-- 个人履历 -->
      <div class="public-item">
        <div class="public-title" style="padding-bottom: 0">
          <img src="@/assets/img/mobileImg/lvli.png" alt="" />
          <span>个人履历</span>
        </div>
      </div>
      <!-- 教育背景 -->
      <div class="public-item">
        <div class="public-title">个人简介</div>
        <div class="public-text">
          <p v-if="individualResume">{{ individualResume }}</p>
          <p v-else class="notData">- 暂无编辑个人简介 -</p>
        </div>
      </div>
      <!-- 教育背景 -->
      <div class="public-item">
        <div class="public-title">教育背景</div>
        <div class="public-text">
          <p v-if="eduExperiences">{{ eduExperiences }}</p>
          <p v-else class="notData">- 暂无编辑教育背景 -</p>
        </div>
      </div>
      <!-- 工作经历 -->
      <div class="public-item">
        <div class="public-title">工作经历</div>
        <div class="public-text">
          <p v-if="workExperiences">{{ workExperiences }}</p>
          <p v-else class="notData">- 暂无编辑工作经历 -</p>
        </div>
      </div>
      <!-- 职称经历 -->
      <div class="public-item">
        <div class="public-title">职称经历</div>
        <div class="public-text">
          <p v-if="titleExperiences">{{ titleExperiences }}</p>
          <p v-else class="notData">- 暂无编辑职称经历 -</p>
        </div>
      </div>
      <!-- 社会任职 -->
      <div class="public-item">
        <div class="public-title">社会任职</div>
        <div class="public-text">
          <p v-if="moonlightingExperiences">{{ moonlightingExperiences }}</p>
          <p v-else class="notData">- 暂无编辑社会任职 -</p>
        </div>
      </div>
      <!-- 获奖情况 -->
      <!-- <div class="public-item">
        <div class="public-title">
          <img src="@/assets/img/mobileImg/win.png"
               alt="">
          <span>获奖情况</span>
        </div>
        <div class="public-text">
          <p v-if="newList">{{newList}}</p>
          <p v-else class="notData">- 暂无编辑获奖情况 -</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Top from '@/views/mobileView/detail/components/Header.vue';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Top,
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
      userInfo: {}, // 用户信息
      orgBaseType: 0, // 机构类型
      organizationStatus: 0, // 机构状态
      title: [], // 职称
      subject: [], // 研究方向
      eduExperiences: "", // 教育背景列表
      moonlightingExperiences: "", // 社会任职列表
      titleExperiences: "", // 职称经历列表
      workExperiences: "", // 工作经历列表
      individualResume: "", // 个人简介
      newList: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 机构类型
    orgType(data) {
      switch (data) {
        case 1:
          console.log("出版单位");
          data = "/magazine";
          break;
        case 2:
          console.log("行业组织");
          data = "/association";
          break;
        case 3:
          console.log("科研机构");
          data = "/appusesinstitutions";
          break;
        case 4:
          console.log("政府机构");
          data = "/government";
          break;
        case 5:
          console.log("院校");
          data = "/university";
          break;
        case 6:
          console.log("其他");
          data = "/other";
          break;
      }
      return data;
    },
    // 跳转各机构
    jumpOrg() {
      let out = this.$route.query.out;
      let web = "web";
      out
        ? this.$router.push(
            `/appusesinstitutions?orgId=${this.userInfo.orgId}&app=${web}&out=${out}`
          )
        : this.$router.push(
            `/appusesinstitutions?orgId=${this.userInfo.orgId}&app=${web}`
          );
    },
    // 获取信息
    getInfo() {
      this.$apis.hundredServe
        .bjDetailList({
          userId: this.$route.query.userId,
        })
        .then((result) => {
          this.userInfo = result.content.detail.userInfo;
          this.orgBaseType = result.content.detail.orgBaseType;
          this.organizationStatus = result.content.detail.organizationStatus;
          this.title = result.content.detail.sysUserTitle;
          this.subject = result.content.detail.sysUserSubject;
          result.content.detail.scholarExperiences.forEach((item) => {
            if (item.type == 6) {
              this.eduExperiences = item.content;
            }
            if (item.type == 7) {
              this.titleExperiences = item.content;
            }
            if (item.type == 8) {
              this.moonlightingExperiences = item.content;
            }
            if (item.type == 9) {
              this.workExperiences = item.content;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取获奖情况
    async spaceScholarPrize(userId) {
      let res = await this.$apis.userServe.spaceScholarPrize({ userId });
      if (res.resultCode == 200) {
        this.newList = res.data.content;
      }
    },
    // 获取个人简介
    async spaceScholarProfile(userId) {
      let res = await this.$apis.userServe.spaceScholarProfile({ userId });
      if (res.resultCode == 200) {
        this.individualResume = res.content.profile;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo();
    this.spaceScholarPrize(this.$route.query.userId);
    this.spaceScholarProfile(this.$route.query.userId);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
};
</script>
<style lang='scss' scoped>
.all {
  background: #e5e5e5;
  margin-top: 70px;
  .top {
    overflow: hidden;
    padding: 0 16px 26px 16px;
    background-color: #fff;
    .logo {
      margin-top: 14px;
      display: flex;
      align-items: center;
      .left {
        margin-right: 10px;
      }
      .right {
        .title {
          font-size: 15px;
          font-family: PingFang;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
}
.public-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
  img {
    width: 20px;
    height: 24px;
    vertical-align: bottom;
    margin-right: 8px;
  }
}
.public-item {
  margin-top: 20px;
}
.public-text {
  font-size: 15px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  p {
    width: 100%;
    white-space: pre-line;
    line-height: 30px;
  }
  span {
    margin-right: 10px;
  }
  .per-name {
    padding: 0 8px;
    display: inline-block;
    border: 1px dashed #4585f5;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #4459d3;
  }
}
.jianjie-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
::v-deep .van-image--round {
  vertical-align: middle;
}
.notData {
  color: #c3c7ce;
}
</style>